import { createUseStyles, useTheme } from 'react-jss';
import { Trans } from 'react-i18next';

import { Theme } from '@app/theme';
import { CenteredLoader, QuestionAnswer } from 'components';
import {
  AnswerText,
  useApplicationAnswers,
  useForm,
  useRecruitment,
  useSession,
} from '@app/api';

import Survey from '@app/illu/Large/Survey.svg';

const useStyles = createUseStyles((theme: Theme) => ({
  emptyContainer: {
    backgroundColor: theme.colors.grayBackground,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: theme.marginBase * 3,
  },
  emptyTitle: {
    ...theme.fonts.label,
    textAlign: 'center',
    marginTop: theme.marginBase * 2,
  },
  status: {
    ...theme.fonts.label,
  },
}));

interface Props {
  applicationId?: string;
  sessionId: string;
}

export const ApplicationDetails = ({ applicationId, sessionId }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const { data: answers, isLoading: isFormResponseLoading } =
    useApplicationAnswers(applicationId, sessionId);

  if (isFormResponseLoading) {
    return <CenteredLoader />;
  }

  if (!answers?.length) {
    return (
      <div className={classes.emptyContainer}>
        <img src={Survey} alt="Empty Form" />
        <h4 className={classes.emptyTitle}>
          <Trans i18nKey="sessions.details.monitoring.screening.empty" />
        </h4>
      </div>
    );
  }

  return (
    <>
      {answers.map((answer: AnswerText) => (
        <QuestionAnswer
          question={answer.question}
          answer={answer.answer}
          key={answer.fieldRef}
          criterionStatus={answer.status}
        />
      ))}
    </>
  );
};
